'use client';

import { CustomDataTable } from '@/components/common';
import { type ProductRelatedPlant } from '@/domain/plant/types';
import { getProductPlants } from '@/domain/products/api';
import { useQuery } from '@tanstack/react-query';
import { Column } from 'primereact/column';
import { Skeleton } from '@andritzot/metris-web-ui/feedback/skeleton';
import { Chip } from '@andritzot/metris-web-ui/data-display/chip';

type PlantsDataTableProps = {
  productId: number;
};

const plantTemplate = (dataRow: ProductRelatedPlant) => (
  <span>
    {dataRow.plant} {dataRow.confidential && <Chip color="warning" size="small" label="Confidential" />}
  </span>
);

const PlantsDataTable = ({ productId }: PlantsDataTableProps) => {
  const { data: plants, isLoading } = useQuery({
    queryKey: ['plants-for-product', productId],
    queryFn: () => getProductPlants(productId),
  });

  if (isLoading) {
    return (
      <div>
        <Skeleton width="100%" height="2rem" />
      </div>
    );
  }

  if (!plants) {
    return null;
  }

  return (
    <CustomDataTable value={plants} dataKey="idPlant" rows={10}>
      <Column field="plant" header="Plant" sortable body={plantTemplate} />
      <Column field="industry.industry" header="Industry" sortable />
      <Column field="country.name" header="Country" sortable />
    </CustomDataTable>
  );
};

export default PlantsDataTable;
